export default __webpack_public_path__ + "static/media/Gauntlets of the Living Tarim.098c7864.jpg";